import { GetterTree } from "vuex";
import { IAppState } from "./state";
import { IUser } from "@/models";

const getters: GetterTree<IAppState, any> = {

    isAuthenticated(state): boolean {
        return !(!state.userAccount);
    },

    applicationVersion(state): string {
        return state.applicationVersion?.concat(process.env.VUE_APP_ENV?.charAt(0).toUpperCase());
    },

    getAdmins(state): IUser[] {
        if (!!state.adminUsers && state.adminUsers.length > 0) {
            return state.adminUsers.map(x => ({ ...x }))
                .sort((a, b) => {
                    return a.name?.localeCompare(b.name);
                });
        } else {
            return [];
        }
    },

    getVips(state): IUser[] {
        if (!!state.vipUsers && state.vipUsers.length > 0) {
            return state.vipUsers.map(x => ({ ...x }))
                .sort((a, b) => {
                    return a.name?.localeCompare(b.name);
                });
        } else {
            return [];
        }
    },
};

export { getters };
